import { routerFrom } from "router";

export const routes = [
  {
    acl: [],
    label: "Company news detail",
    name: "client.news-detail",
    path: "/app/company/:slug/news/:newsId",
  },
  {
    acl: [],
    label: "Company",
    name: "client",
    path: "/app/company/:slug",
  },
  {
    acl: [],
    label: "Company details",
    name: "client.details",
    path: "/app/company/:slug/?tab=details",
  },
  {
    acl: [],
    label: "Company jobs",
    name: "client.jobs",
    path: "/app/company/:slug/?tab=jobs",
  },
  {
    acl: [],
    label: "Company location",
    name: "client.location",
    path: "/app/company/:slug/?tab=location",
  },
  {
    acl: [],
    label: "Company news",
    name: "client.news",
    path: "/app/company/:slug/?tab=news",
  },
  {
    acl: [],
    label: "News detail",
    name: "news.news-detail",
    path: "/app/news/:newsId",
  },
  {
    acl: [],
    label: "News",
    name: "news",
    path: "/app/news",
  },
];

export const publicRoutes = [
  {
    acl: [],
    label: "Company news detail",
    name: "public-client.news-detail",
    path: "/company/:slug/news/:newsId",
  },
  {
    acl: [],
    label: "Company",
    name: "public-client",
    path: "/company/:slug",
  },
  {
    acl: [],
    label: "Company details",
    name: "public-client.details",
    path: "/company/:slug/?tab=details",
  },
  {
    acl: [],
    label: "Company jobs",
    name: "public-client.jobs",
    path: "/company/:slug/?tab=jobs",
  },
  {
    acl: [],
    label: "Company location",
    name: "public-client.location",
    path: "/company/:slug/?tab=location",
  },
  {
    acl: [],
    label: "Company news",
    name: "public-client.news",
    path: "/company/:slug/?tab=news",
  },
  {
    acl: [],
    label: "News detail",
    name: "public-news.news-detail",
    path: "/news/:newsId",
  },
  {
    acl: [],
    label: "News",
    name: "public-news",
    path: "/news",
  },
];

export const router = routerFrom(routes);
export const publicRouter = routerFrom(publicRoutes);
